import { render, staticRenderFns } from "./MobileConcatUs.vue?vue&type=template&id=0260a6c4&scoped=true"
import script from "./MobileConcatUs.vue?vue&type=script&lang=js"
export * from "./MobileConcatUs.vue?vue&type=script&lang=js"
import style0 from "./MobileConcatUs.vue?vue&type=style&index=0&id=0260a6c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0260a6c4",
  null
  
)

export default component.exports